import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Error, LoadingSpinner } from '../../components'
import getAuth0 from '../../utils/auth0'
import { newRelicTriggerErrorEvent } from '../../utils/newrelic'

export default function BrowseLogout(): JSX.Element {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<{ code: string } | null>(null)

  useEffect(() => {
    ;(async () => {
      try {
        const auth0 = getAuth0()
        await auth0.atg.signOut()
        await auth0.logout({
          openUrl: false,
        })
        const continueTo = searchParams.get('continueTo') || `${window.location.origin}/#homepage`
        window.location.replace(
          `${window.auth.ACCOUNT_URL}/sign-in-details/logout?continueTo=${continueTo}`,
        )
      } catch (error) {
        console.error(error)
        newRelicTriggerErrorEvent('browse-logout', error)
        setError({ code: 'browse.logout.error' })
      }
    })()
  }, [])

  return <div data-testid="browse-logout">{error ? <Error /> : <LoadingSpinner />}</div>
}
